export function orderTotalCalculate(row, products = []) {

  const coupon_price = row?.coupon_price ?? 0;
  const delivery_charges = row?.delivery_charges ?? 0;
  const paidAmount = row?.paid_amount ?? 0;
  var total = 0;
  // product calculate
  let totalOrderSubTotal = 0;

  try {

    let rows = products ? products : row?.products;

    for (let product of Array.from(rows)) {
      const price = product?.price ?? 0;
      const quantity = product?.quantity ?? 0;
      const rowTotal = price * quantity;
      totalOrderSubTotal += rowTotal;
    }

    total = (totalOrderSubTotal + delivery_charges) - (coupon_price + paidAmount);
  } catch (error) {
    // 
  }

  const data = {
    sub_total: totalOrderSubTotal,
    total,
    delivery_charges,
    coupon_price
  }

  return data;
}

export function getStatus(status) {
  return String(status).replace('order_', '').replace('_', ' ');
}

export function generateUniqueSlug(title, timestampAdd = true) {
  if (!title) {
    return '';
  }
  // Convert the title to lowercase
  let slug = title.toLowerCase();
  // Remove special characters, except hyphen and space
  slug = slug.replace(/[^\w\s-]/g, '');
  // Replace spaces with hyphens
  slug = slug.replace(/\s+/g, '-');

  if (!timestampAdd) {
    return slug;
  }

  const timestamp = String(new Date().getTime()).split('');
  slug = `${slug}-${timestamp.slice(7, timestamp.length).join('')}`;

  return slug;
}
